module.exports = __webpack_public_path__ + "static/media/ALF Core Training Course_1591037208031.acecd17b.docx";